"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable camelcase */
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
exports.concentrationLimitPointerMethods = [
    {
        method: 'rampGoldmanSachs1.maxSingleObligor',
        pointerImplementation: ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
            const concentrationLimitValueType = valueConfig.valueType;
            const concentrationLoanTapeRecords = _.orderBy(concentrationReceivables, (receivable) => receivable.concentrationLimitFields
                .eligibleExposureLessConcentrationLimitKickouts, 'desc');
            const topObligor = concentrationLoanTapeRecords[0];
            (0, common_1.finleyAssert)(topObligor, 'should have at least one concentration record for maxSingleObligor');
            // 5/20/22 - amendment:
            // We will need to update the top single obligor for last 5 days of each calendar month
            // If the GLA of the top obligor is >$50,000,000 the concentration limit goes from 5% to 7.5%
            let finalConcentrationLimit = valueConfig.limit;
            const currDate = common_1.date.currentDateTime();
            if (currDate.day > currDate.endOf('month').day - 5 &&
                Number(topObligor.baseFields.gla) > 50000000) {
                finalConcentrationLimit = 0.075;
            }
            return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit: finalConcentrationLimit,
                totalConcentrationExposure,
                concentrationReceivables: [topObligor],
                concentrationLimitValueType,
            });
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map